<template>
  <v-card>
    <v-card-title>
      Filter by
    </v-card-title>
    <v-card-text>
      <v-radio-group v-model="filter">
        <v-radio
            v-for="item of filterItems"
            :value="item.value"
            :label="item.title"
            :key="item.value"
        >
        </v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
import {sync} from "vuex-pathify";

export default {
  name: "ApplicationListFilterBox",
  data() {
    return {
      filterItems: [
        {
          title: "All",
          value: "All"
        },
        {
          title: "Active",
          value: "Active"
        },
        {
          title: "Inactive",
          value: "Inactive"
        }
      ]
    }
  },
  computed: {
    filter: sync('application/filter')
  }
}
</script>

<style scoped>

</style>
